import React from 'react';

function RecipeTitle({ title, onChange, readOnly, pdfExport = false }) {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center text-center px-[3%]">
      <label
        htmlFor="recipeTitleInput"
        className={`font-semibold text-[#5a3e36] leading-tight ${
          pdfExport ? 'text-[16px]' : 'text-[clamp(0.75rem,1.6vw,1.1rem)]'
        }`}
      >
        Recipe:
      </label>

      {readOnly ? (
        <h1
          className={`font-serif text-[#5a3e36] truncate w-full leading-tight ${
            pdfExport ? 'text-[20px]' : 'text-[clamp(0.75rem,2.2vw,1.25rem)]'
          }`}
        >
          {title?.trim()
            ? title
            : <span className="text-transparent select-none">.</span>}
        </h1>
      ) : (
        <input
          id="recipeTitleInput"
          type="text"
          value={title}
          onChange={(e) => onChange(e.target.value)}
          placeholder={title === '' ? '' : "E.g., Grandma's Classic Apple Pie"}
          className={`
            mt-[1.3%]
            w-full max-w-[90vw] sm:max-w-[24rem] md:max-w-[26rem] px-4
            ${pdfExport 
              ? 'h-[32px] leading-[32px] text-[18px]' 
              : 'h-[clamp(1.5rem,2.3vw,2rem)] leading-[clamp(1.6rem,2.4vw,2.2rem)] text-[clamp(1rem,2.2vw,1.4rem)]'}
            font-serif
            border border-[#e0c3a5] rounded
            bg-white text-center box-border
            truncate
          `}
        />
      )}
    </div>
  );
}

export default RecipeTitle;